module.exports = __webpack_public_path__ + "img/Pack_remise.9e2d138e.jpg";